import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import KeyboardArrorRight from '@material-ui/icons/KeyboardArrowRight'
import { Link } from 'react-router-dom'

const styles = {
    divContainer: {
        width: 540,
        height: 70,
        borderRadius: 59,
        border: "1px solid #d8d8d8",
        margin: "auto",
        '&:hover': {
            backgroundColor: "#f5f5f6",
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.12)",
        },
    },
    label: {
        width: 450,
        height: 24,
        paddingLeft: 15,
        color: "#333333",
        fontFamily: "Work Sans",
        fontSize: 18,
        fontWeight: 400,
        margin: 0,
        '&:hover': {
            cursor: "pointer",
        },
    },
    link: {
        textDecoration: "none !important",
        color: "#333333",
        fontFamily: "Work Sans",
        fontSize: 18,
        fontWeight: 400,
        '&:hover': {
            color: "#333333",
        },
    }
}

const ItemAtendimento = (props) => {
    const { iconePath, alt, redirect_path, content, classes } = props;
    return (
        <div className={classes.divContainer}>
            <Link className={classes.link} to={redirect_path}>
                <div className={"divContainerInterno"}>
                    <div className={"divExterior"}>
                        <div className={"divInterior"}>
                            <img
                                style={{ marginLeft: 5, width: 55 }}
                                src={iconePath}
                                alt={alt}
                            />
                        </div>
                    </div>
                </div>
                <div className={"divContainerInterno"}>
                    <div className={"divExterior"}>
                        <div className={"divInterior"}>
                            <label className={classes.label}>
                                {content}
                            </label>
                        </div>
                    </div>
                </div>
                <div className={"divContainerInterno"}>
                    <div className={"divExterior"}>
                        <div className={"divInterior"}>
                            <KeyboardArrorRight
                                style={{ display: "block" }}
                            />
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    )
}

export default withStyles(styles)(ItemAtendimento)
